import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import Item from './Item';
import { connect } from 'react-redux';
import Loading, { MdLoaderTheme } from '../../../common/Loading';
import Legend from '../orderType/Legend';
import { compose } from 'recompose';
import InfiniteScroll from 'redux-infinite-scroll';
import {
  loadPaginationItems,
  selectSubcategory,
  loadInfiniteSubcategory,
  assignItemValues,
  changeCategoryId,
  infiniteScrollDown,
  subMenuClicked,
} from '../../../menu/actions';
import { FormattedMessage } from 'react-intl';
import IsScrolling from 'react-is-scrolling';
import defaultMsg from '../../../../translations/lang/en-US.json';

const lodash = require('lodash');

/*let subMenu = '';
const withInfiniteScroll = Component =>
  class WithInfiniteScroll extends React.Component {
    componentDidMount() {
      window.addEventListener('scroll', this.onScroll, false);
    }

    componentWillUnmount() {
      window.removeEventListener('scroll', this.onScroll, false);
    }

    onScroll = () => {};

    render() {
      return <Component {...this.props} />;
    }
  };

const List = ({ list }) => (
  <div className="list">{console.log('childresn ', { list })}</div>
);*/

class Items extends Component {
  constructor(props) {
    super(props);
    this.state = Object.assign(
      {},
      {
        menuItems: [],
        loading: false,
        pageNum: 2,
        loadingMore: false,
        hasMoreProp: true,
        allowHasMore: true,
        modalPopped: false,
        height: window.screen.availHeight - 300,
        heartHealty: false,
        gluten: false,
        dairy: false,
        selectNextCategory: false,
      },
      this.enableLegendIcons(this.props.menuItems)
    );

    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
    this.enableLegendIcons = this.enableLegendIcons.bind(this);
  }
  scroll = () => {
    if (
      document.documentElement.scrollHeight - window.innerHeight ==
      window.pageYOffset
    ) {
      // you're at the bottom of the page
      const { hasMoreProp, loadingMore } = this.state;
      if (!hasMoreProp || loadingMore) {
        return;
      }
      this._loadMore();
    }
  };
  // This is for edge case scenario.
  // When scrollbar itself is not present, loadMoreItems if present.
  loadMoreIfNoScrollbar = () => {
    if (!(window.innerWidth > document.documentElement.clientWidth)) {
      this._loadMore();
    }
  };

  componentDidMount() {
    window.addEventListener('resize', this.updateWindowDimensions);
    window.addEventListener('scroll', this.scroll);
    this.updateWindowDimensions();
    this.loadMoreIfNoScrollbar();
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
    window.removeEventListener('scroll', this.scroll);
  }
  updateWindowDimensions() {
    const header = document.getElementById('mainHeader');
    const subHeader = document.getElementById('subHeader');
    const healthyIconsLegends = document.getElementById('healthy-icons');
    const footer = document.getElementById('app-footer');
    const getOffset = element => (element ? element.offsetHeight : 0);
    if (header && subHeader) {
      const height =
        window.innerHeight -
        getOffset(header) -
        getOffset(subHeader) -
        getOffset(footer) -
        getOffset(healthyIconsLegends) -
        28;

      if (this.state.height !== height) {
        this.setState({
          height: height,
        });
      }
    }
  }

  componentDidUpdate(prevProps, prevState) {
    this.updateWindowDimensions();
    this.loadMoreIfNoScrollbar();
    /* var elem = document.getElementsByClassName('redux-infinite-scroll');
    if (
      this.refs[this.props.subMenuItemClicked] &&
      subMenu !== this.refs[this.props.subMenuItemClicked] &&
      this.props.infiniteScroll === true &&
      this.props.clickBoolean &&
      this.props.clickBoolean === true
    ) {
      this.props.dispatch(subMenuClicked(false));
      subMenu = this.refs[this.props.subMenuItemClicked];
      if (window.screen.width < 500) {
        window.scrollTo(0, this.refs[this.props.subMenuItemClicked].offsetTop);
        this.refs[this.props.subMenuItemClicked].style.marginTop = '50px';
      } else {
        console.log(
          'offset top',
          this.refs[this.props.subMenuItemClicked].offsetTop
        );
        window.scrollTo(0, this.refs[this.props.subMenuItemClicked].offsetTop);
      }
    }*/
  }

  mouseEnter(subItemId, parentId) {
    if (window.innerWidth < 700) {
      var orderBy = lodash.result(
        lodash.find(this.props.totalMenus, function(obj) {
          return obj.id === parentId;
        }),
        'orderby'
      );
      var subelmnt = document.getElementById('subMenu_' + subItemId);
      var mainElement = document.getElementById('main' + parentId);
      if (subelmnt) {
        subelmnt.scrollIntoView();
      }
      if (mainElement) {
        mainElement.scrollIntoView();
      }
    }
    this.props.dispatch(assignItemValues(parentId, subItemId, orderBy));
  }

  _renderItems() {
    return this.props.menuItems.map(item => {
      return (
        <Item
          key={lodash.uniqueId('Item_')}
          {...item}
          switchModal={clickedItem => this.switchModal(clickedItem)}
        />
      );
    });
  }

  /* _renderItems() {
    let itemDivStyle = {
      float: 'left',
      width: '100%',
      paddingBottom: '30px'
    };

    return this.props.menuArray.map(itemData => {
      return itemData.mainMenuItem.map(mainItem => {
        if (
          mainItem.menuItems &&
          mainItem.parentid === this.props.mainMenuItemClicked
        ) {
          let targetId = mainItem.parentid + '-' + mainItem.id;
          return (
            <div
              className="targetId"
              id={targetId}
              value={mainItem.parentid}
              // onMouseOver={() =>
              //   this.mouseEnter(mainItem.id, mainItem.parentid)
              // }
              onTouchStart={() =>
                this.mouseEnter(mainItem.id, mainItem.parentid)
              }
              style={itemDivStyle}
              ref={mainItem.id}
              value={mainItem.id}
              onScroll={e => this.onScrollItem(e)}
            >
              <div className="category-header" >{mainItem.text}</div>
              {mainItem.menuItems.map(item => {
                return (
                  <Item
                    key={lodash.uniqueId('Item_')}
                    {...item}
                    switchModal={clickedItem => this.switchModal(clickedItem)}
                  />
                );
              })}
            </div>
          );
        }
      });
    });
  }*/

  enableLegendIcons(item) {
    if (
      (item && !this.state) ||
      (this.state &&
        (!this.state.heartHealty || !this.state.gluten || !this.state.dairy))
    ) {
      const noOfItems = item.length;

      const isActive = (status, isMadeActive) => {
        return Number(status) === 1 || isMadeActive;
      };
      const filter = {
        heartHealty: false,
        gluten: false,
        dairy: false,
      };
      for (var i = 0; i < noOfItems; i++) {
        if (filter.heartHealty && filter.gluten && filter.dairy) {
          break;
        }
        if (item[i]) {
          filter.heartHealty = isActive(
            item[i].heart_healthy,
            filter.heartHealty
          );
          filter.gluten = isActive(item[i].contains_gluten, filter.gluten);
          filter.dairy = isActive(item[i].contains_dairy, filter.dairy);
        }
      }
      return filter;
    } else {
      return {};
    }
  }

  componentWillReceiveProps(nextProps) {
    if (window.modalPopped === false) {
      this.setState({
        loading: nextProps.loading,
        hasMoreProp: true,
        allowHasMore: true,
        heartHealty:
          this.props.loading && this.state.heartHealty
            ? false
            : this.state.heartHealty,
        gluten:
          this.props.loading && this.state.gluten ? false : this.state.gluten,
        dairy:
          this.props.loading && this.state.dairy ? false : this.state.dairy,
      });

      if (nextProps.menuItems !== null) {
        if (nextProps.menuItems.length <= 8) {
          this.setState({ pageNum: 2 });
        }

        if (
          nextProps.menuItems.length >= nextProps.pager.total_entries ||
          parseInt(nextProps.pager.current_page) ===
            parseInt(nextProps.pager.total_pages)
        ) {
          this.setState({
            hasMoreProp: true,
            allowHasMore: false,
          });
        }
      }
    }

    this.setState(this.enableLegendIcons(this.props.menuItems));

    if (window.modalPopped === -1) {
      window.modalPopped = false;
    }
  }

  switchModal(clickedItem) {
    this.props.switchModal(clickedItem);
  }

  _loadMore() {
    const { hasMoreProp, loadingMore } = this.state;
    if (!hasMoreProp || loadingMore) {
      return;
    }
    this.setState(
      {
        loadingMore: true,
        hasMoreProp: false,
      },
      () => {
        // CB emulates an ajax request
        if (this.state.allowHasMore) {
          this.props
            .dispatch(
              loadPaginationItems(
                JSON.parse(JSON.stringify(this.props.menuItems)),
                this.props.subMenuItemClicked,
                this.state.pageNum,
                this.props.tokenId,
                this.props.jwt,
                this.props.dashboardData.dataName,
                this.props.dashboardData.modeOfOrder
              )
            )
            .then(res => {
              if (
                res.prevItems === null ||
                res.prevItems.length === 0 ||
                res.newItems.length >= res.pagination.total_entries ||
                parseInt(res.pagination.current_page) ===
                  parseInt(res.pagination.total_pages)
              ) {
                this.setState({
                  loadingMore: false,
                  hasMoreProp: false,
                });
              } else {
                this.setState({
                  loadingMore: false,
                  pageNum: this.state.pageNum + 1,
                });
              }
            });
        } else {
          this.setState({
            loadingMore: false,
            hasMoreProp: false,
          });
        }
        this.setState({
          allowHasMore: false,
        });
      }
    );
  }

  /* _loadMore() {
    this.setState(
      {
        loadingMore: true,
        hasMoreProp: false,
      },
      () => {
        // CB emulates an ajax request
        if (this.state.allowHasMore) {
          this.props
            .dispatch(
              loadPaginationItems(
                JSON.parse(JSON.stringify(this.props.menuArray[0])),
                JSON.parse(JSON.stringify(this.props.menuItems)),
                this.props.subMenuItemClicked,
                this.state.pageNum,
                this.props.tokenId,
                this.props.jwt,
                this.props.dashboardData.dataName,
                this.props.dashboardData.modeOfOrder
              )
            )
            .then(res => {
              if (
                res.prevItems === null ||
                res.prevItems.length === 0 ||
                res.newItems.length >= res.pagination.total_entries ||
                parseInt(res.pagination.current_page) ===
                  parseInt(res.pagination.total_pages)
              ) {
                this.setState({
                  loadingMore: false,
                  hasMoreProp: false,
                });
              } else {
                this.setState({
                  loadingMore: false,
                  pageNum: this.state.pageNum + 1,
                });
              }
            });
        } else {
          console.log(' else allowHasMore');
          this.setState({
            loadingMore: false,
            hasMoreProp: false,
          });
        }
        this.setState({
          allowHasMore: false,
        });
      }
    );
  }*/

  /* _loadMore() {
    this.setState(
      {
        loadingMore: true,
        hasMoreProp: false,
        // selectNextCategory: true,
      },
      () => {
        // CB emulates an ajax request
        if (this.state.allowHasMore) {
          this.props.menuArray.map(itemData => {
            itemData.mainMenuItem.map(mainItem => {
              if (
                mainItem.id === this.props.subMenuItemClicked &&
                mainItem.parentid === this.props.mainMenuItemClicked &&
                mainItem.menuItems.length < mainItem.totalNumberOfItems
              ) {
                this.setState({ selectNextCategory: true });
                this.props
                  .dispatch(
                    loadPaginationItems(
                      JSON.parse(JSON.stringify(this.props.menuArray)),
                      JSON.parse(JSON.stringify(this.props.menuItems)),
                      this.props.subMenuItemClicked,
                      this.props.mainMenuItemClicked,
                      this.state.pageNum,
                      this.props.tokenId,
                      this.props.jwt,
                      this.props.dashboardData.dataName,
                      this.props.dashboardData.modeOfOrder
                    )
                  )
                  .then(res => {
                    if (
                      res.prevItems === null ||
                      res.prevItems.length === 0 ||
                      res.newItems.length >= res.pagination.total_entries ||
                      parseInt(res.pagination.current_page) ===
                        parseInt(res.pagination.total_pages)
                    ) {
                      this.setState({
                        loadingMore: false,
                        hasMoreProp: true,
                        selectNextCategory: true,
                      });
                    } else {
                      this.setState({
                        loadingMore: false,
                        hasMoreProp: true,
                        pageNum: this.state.pageNum + 1,
                        selectNextCategory: true,
                      });
                    }
                  });
              } else {
                this.setState({ loadingMore: true, hasMoreProp: true });
              }
            });
          });
        } else {
          this.setState({
            loadingMore: false,
            hasMoreProp: false,
          });

          this.props.menuArray.map(itemData => {
            itemData.mainMenuItem.map((mainItem, index) => {
              if (this.state.selectNextCategory === true) {
                this.setState({ selectNextCategory: false });
                this.props
                  .dispatch(
                    selectSubcategory(
                      mainItem.id,
                      mainItem.parentid,
                      mainItem.text,
                      this.props.dashboardData.modeOfOrder,
                      this.props.tokenId,
                      this.props.jwt,
                      this.props.dashboardData.dataName,
                      this.props.menuItems,
                      this.props.menuArray
                    )
                  )
                  .then(res => {
                    this.setState({
                      loadingMore: false,
                      hasMoreProp: false,
                      selectNextCategory: false,
                    });
                  });
              }
            });
          });
        }
        // this.setState({
        //   allowHasMore: false,
        // });
      }
    );
  }

 infiniteItems() {
    if (this.props.infiniteBoolValue === false) {
      this.props.menuArray.map((itemData, index) => {
        itemData.mainMenuItem.map((mainItem, subindex) => {
          if (
            mainItem.id === this.props.subMenuItemClicked &&
            mainItem.parentid === this.props.mainMenuItemClicked &&
            mainItem.menuItems.length < mainItem.totalNumberOfItems
          ) {
            this.props
              .dispatch(
                loadPaginationItems(
                  JSON.parse(JSON.stringify(this.props.menuArray)),
                  JSON.parse(JSON.stringify(this.props.menuItems)),
                  this.props.subMenuItemClicked,
                  this.props.mainMenuItemClicked,
                  this.state.pageNum,
                  this.props.tokenId,
                  this.props.jwt,
                  this.props.dashboardData.dataName,
                  this.props.dashboardData.modeOfOrder
                )
              )
              .then(res => {
                if (
                  res.prevItems === null ||
                  res.prevItems.length === 0 ||
                  res.newItems.length >= res.pagination.total_entries ||
                  parseInt(res.pagination.current_page) ===
                    parseInt(res.pagination.total_pages)
                ) {
                  this.setState({
                    loadingMore: false,
                    hasMoreProp: false,
                    selectNextCategory: true,
                  });
                } else {
                  this.setState({
                    loadingMore: false,
                    pageNum: this.state.pageNum + 1,
                    selectNextCategory: true,
                  });
                }
              });
          } else {
            this.props
              .dispatch(
                loadInfiniteSubcategory(
                  mainItem.id,
                  mainItem.parentid,
                  mainItem.text,
                  this.props.dashboardData.modeOfOrder,
                  this.props.tokenId,
                  this.props.jwt,
                  this.props.dashboardData.dataName,
                  this.props.menuItems,
                  this.props.menuArray
                )
              )
              .then(res => {
                this.setState({
                  selectNextCategory: false,
                });
              });
            //}
          }
        });
      });
    } else {
    }
  }

  scrollDown() {
    if (window.innerWidth > 700) {
      const node = document.getElementsByClassName('targetId');
      const nodelist = document.querySelectorAll('.targetId');
      const divyArray = Array.from(nodelist);
      //this._input.current.focus();
      divyArray.map(index => {
        let subHeader = document.getElementById('content').offsetTop;
        if (
          document
            .getElementById(index.getAttribute('id'))
            .getBoundingClientRect().top < 150
        ) {
          console.log('id', index.getAttribute('id'));
          console.log(
            'test',
            document
              .getElementById(index.getAttribute('id'))
              .getBoundingClientRect().top
          );
          console.log(
            'test',
            document
              .getElementById(index.getAttribute('id'))
              .getBoundingClientRect().top
          );
          console.log(
            'difference',
            document.getElementById(index.getAttribute('id')).scrollHeight +
              (document.getElementById('content').offsetHeight -
                document.getElementById('content').clientHeight)
          );
          var orderBy = lodash.result(
            lodash.find(this.props.totalMenus, function(obj) {
              return obj.id === index.getAttribute('id').split('-')[0];
            }),
            'orderby'
          );
          var subelmnt = document.getElementById(
            'subMenu_' + index.getAttribute('id').split('-')[1]
          );
          var mainElement = document.getElementById(
            'main' + index.getAttribute('id').split('-')[0]
          );
          if (subelmnt) {
            subelmnt.scrollIntoView();
          }
          if (mainElement) {
            mainElement.scrollIntoView();
          }

          this.props.dispatch(
            assignItemValues(
              index.getAttribute('id').split('-')[0],
              index.getAttribute('id').split('-')[1],
              orderBy
            )
          );
        }
      });
    }
    if (this.props.infiniteScroll !== true) {
      this.props.dispatch(infiniteScrollDown(true));
    }
  }
  onScrollItem(e) {
    console.log('test scroll *******', e);
  }
  infiniteScrollUp() {
    if (window.innerWidth > 700) {
      const node = document.getElementsByClassName('targetId');
      const nodelist = document.querySelectorAll('.targetId');
      const divyArray = Array.from(nodelist);
      divyArray.map(index => {
        let subHeader = document.getElementById('content').offsetTop;
        console.log('id outside', index.getAttribute('id'));
        console.log(
          'test outside',
          document
            .getElementById(index.getAttribute('id'))
            .getBoundingClientRect().top
        );
        if (
          document
            .getElementById(index.getAttribute('id'))
            .getBoundingClientRect().top < 150
        ) {
          console.log('id', index.getAttribute('id'));
          console.log(
            'test',
            document
              .getElementById(index.getAttribute('id'))
              .getBoundingClientRect().top
          );
          console.log(
            'test',
            document
              .getElementById(index.getAttribute('id'))
              .getBoundingClientRect().top
          );
          console.log(
            'difference',
            document.getElementById(index.getAttribute('id')).scrollHeight +
              (document.getElementById('content').offsetHeight -
                document.getElementById('content').clientHeight)
          );
          var orderBy = lodash.result(
            lodash.find(this.props.totalMenus, function(obj) {
              return obj.id === index.getAttribute('id').split('-')[0];
            }),
            'orderby'
          );
          var subelmnt = document.getElementById(
            'subMenu_' + index.getAttribute('id').split('-')[1]
          );
          var mainElement = document.getElementById(
            'main' + index.getAttribute('id').split('-')[0]
          );
          if (subelmnt) {
            subelmnt.scrollIntoView();
          }
          if (mainElement) {
            mainElement.scrollIntoView();
          }

          this.props.dispatch(
            assignItemValues(
              index.getAttribute('id').split('-')[0],
              index.getAttribute('id').split('-')[1],
              orderBy
            )
          );
        }
      });
    }
    if (this.props.infiniteScroll !== false) {
      this.props.dispatch(infiniteScrollDown(false));
    }
  }*/
  render() {
    // const { isScrolling, isScrollingDown, isScrollingUp } = this.props;

    const isEmpty = lodash.get(this, 'props.menuItems', []).length < 1;
    const { heartHealty, gluten, dairy } = this.state;
    if (this.state.loading) {
      return <Loading />;
    } else if (isEmpty) {
      return (
        <div
          id="content"
          name="items"
          className="col-xs-12 col-sm-8 col-md-8 col-lg-9 mainContent"
        >
          <div className="alert alert-error font-medium text-center">
            <FormattedMessage
              id="noItemsFound"
              defaultMessage={defaultMsg.noItemsFound}
            />
          </div>
        </div>
      );
    } else if (!isEmpty) {
      return (
        <div
          id="content"
          name="items"
          className="col-xs-9 col-sm-9 col-md-9 col-lg-9 mainContent"
        >
          {/* updateWindowDimensions */}
          <Legend active={{ heartHealty, gluten, dairy }} />
          <div>
            {this._renderItems()}
            {this.state.loadingMore && (
              <div className="row">
                <div className="col-md-12 loading-more-items">
                  <MdLoaderTheme size={40} />
                </div>
              </div>
            )}
          </div>
        </div>
      );
    }
  }
}

function mapStateToProps(state) {
  return {
    authenticated: state.auth.authenticated,
    subMenuItemClicked: state.menuCategories.subMenuItemClicked,
    mainMenuItemClicked: state.menuCategories.mainMenuItemClicked,
    menuItems: state.menuCategories.menuItems,
    pager: state.menuCategories.pager,
    loading: state.menuCategories.loading,
    tokenId: state.auth.tokenId,
    jwt: state.auth.jwt,
    menuArray: state.menuCategories.menuArray,
    infiniteBoolValue: state.menuCategories.infiniteBoolValue,
    totalMenus: state.menuCategories.menuCategories.menu_category,
    infiniteScroll: state.menuCategories.infiniteScroll,
    clickBoolean: state.menuCategories.clickBooleanSubMenu,
  };
}

//const ListWithLoadingWithInfinite = compose(withInfiniteScroll)(List);

//export default connect(mapStateToProps)(IsScrolling(Items));
export default connect(mapStateToProps)(Items);



// WEBPACK FOOTER //
// ./src/views/dashboard/components/items/Items.jsx